import React from 'react';
import styles from './AuditionDetailBack.module.css';

/**
 * @component AuditionDetailBack
 * @description 이전 페이지로 돌아가기 버튼
 *
 * @param {Function} props.onClick - 클릭 핸들러
 * @param {string} [props.label] - 버튼 라벨 (기본값: '공고 목록으로')
 */
function AuditionDetailBack({ onClick, label = '공고 목록으로' }) {
  return (
    <button className={styles.back} onClick={onClick}>
      <span className={styles.arrow} aria-hidden="true">←</span>
      <span>{label}</span>
    </button>
  );
}

export default AuditionDetailBack;
